import React from 'react';

import { OngoingIncidents } from './OngoingIncidents';
import { ScheduledMaintenances } from './ScheduledMaintenances';
import { useStatusPageSummary } from './useStatusPageSummary';

/**
 * Banners driven by the public Incident.io status page: ongoing (and recently
 * resolved) incidents, plus in-progress and upcoming maintenance.
 */
export const StatusPageBanners = () => {
  const summary = useStatusPageSummary();

  return (
    <>
      <OngoingIncidents incidents={summary?.ongoing_incidents} />
      <ScheduledMaintenances
        maintenances={
          summary
            ? [
                ...summary.in_progress_maintenances,
                ...summary.scheduled_maintenances,
              ]
            : []
        }
      />
    </>
  );
};
